/**
 * @Author: Li, Yu Jia
 * @Date: 2020-03-21 15:15:46
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-03-21 15:16:09
 */

import TokenExpiration from './TokenExpiration';

export default TokenExpiration;
